import React from "react";
import { doctorProfileFiles } from "../../../../Util/API Calls/APIList";
import "./style.scss";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";

const DoctorContactsNew = ({
  id,
  doctor_phone_no,
  selected,
  handleCheckDoctorContacts,
  doctor_first_name,
  prefix_name,
  doctor_last_name,
  doctor_profile_picture_url,
  is_resource,
}) => {
  return (
    <div className="contact-container">
      <input
        id={id}
        type={"checkbox"}
        onClick={handleCheckDoctorContacts}
        className={"d-none"}
        checked={selected}
        key={id}
        value={id}
      />
      <div className="d-flex my-3">
        <label htmlFor={id} className="no-image m-0 mr-3">
          {selected ? (
            <p className="m-0 initials">
              {" "}
              <CheckOutlinedIcon />
            </p>
          ) : doctor_profile_picture_url?.length > 0 &&
            doctor_profile_picture_url !== "" ? (
            <img
              className={
                doctor_profile_picture_url?.length > 0
                  ? "profile-picture"
                  : "no-image"
              }
              src={doctor_profile_picture_url[0]} //doctorProfileFiles +
              alt=""
            />
          ) : (
            <p className="initials m-0">
              {doctor_first_name?.trim()?.charAt(0)}
            </p>
          )}
        </label>
        <div className="name-container">
          <label
            htmlFor={id}
            className={"d-flex align-items-center m-0 flex-column"}
          >
            <p className="m-0 dr-name" style={{ textTransform: "capitalize" }}>
              {is_resource && is_resource === "True"
                ? `${
                    prefix_name
                      ? prefix_name?.trim().includes(".")
                        ? prefix_name?.trim()
                        : prefix_name?.trim() + "."
                      : ""
                  } ${doctor_first_name?.trim()}  ${doctor_last_name?.trim()}`
                : `${
                    prefix_name
                      ? prefix_name?.trim()?.includes(".")
                        ? prefix_name?.trim()
                        : prefix_name?.trim() + "."
                      : "Dr."
                  } ${doctor_first_name?.trim()} ${doctor_last_name?.trim()}`}
            </p>
          </label>

          <p className="m-0">
            <small>{doctor_phone_no}</small>
          </p>
        </div>
      </div>
    </div>
  );
};

export default DoctorContactsNew;
